import { useLanguage } from '../context/LanguageContext'
import { useIsDark } from '../hooks/useIsDark'

const LanguageSwitcher = () => {
	const { language, toggleLanguage } = useLanguage()
	const isDark = useIsDark()

	return (
		<button
			onClick={toggleLanguage}
			className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-sm font-medium transition-all duration-300 cursor-pointer ${
				isDark
					? 'text-white/70 hover:text-white hover:bg-white/10'
					: 'text-slate-900/70 hover:text-slate-900 hover:bg-black/5'
			}`}
			aria-label={language === 'es' ? 'Switch to English' : 'Cambiar a español'}
		>
			<svg
				className='w-4 h-4'
				fill='none'
				stroke='currentColor'
				viewBox='0 0 24 24'
			>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9'
				/>
			</svg>
			<span className='uppercase tracking-wider'>
				{language === 'es' ? 'EN' : 'ES'}
			</span>
		</button>
	)
}

export default LanguageSwitcher
